import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export class AnimatedLabelPlaceholder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      focussed: false,
      locked: false
    };
  }

  onFocus = val => {
    if (val) {
      this.setState({
        focussed: true,
        locked: true
      });
    }
  };

  onBlur = val => {
    if (!val) {
      this.setState({
        focussed: false,
        locked: false
      });
    } else {
      this.setState({
        focussed: false,
        locked: true
      });
    }
  };

  render() {
    const { focussed, locked } = this.state;
    const { value, input, hasError, warning } = this.props;
    const inputAddProps = React.cloneElement(input, {
      onFocus: val => this.onFocus(val),
      onBlur: val => this.onBlur(val)
    });

    return (
      <div className='labelPlaceholderContainer'>
        <label
          htmlFor={input.props.name}
          className={classnames('serveAsPlaceholder body-3 text-color-secondary', {
            'serveAsLabel text-color-primary-dark u-bold':
              focussed || inputAddProps.props.value || (inputAddProps.props.value && locked),
            'text-color-error': hasError
          })}
        >
          {value}
        </label>
        {inputAddProps}
        {warning}
      </div>
    );
  }
}

AnimatedLabelPlaceholder.defaultProps = {
  value: '',
  input: null,
  hasError: false,
  warning: null
};

AnimatedLabelPlaceholder.propTypes = {
  value: PropTypes.string,
  input: PropTypes.object,
  hasError: PropTypes.bool,
  warning: PropTypes.object
};

export default AnimatedLabelPlaceholder;
